import { writable } from 'svelte/store';
export const salesPriceData = writable([]);
export const salesPriceDataOnce = writable([]);
export const packagesData = writable([]);